function SkillCategory({ category }) {
  return (
    <div className="skill-category reveal">
      <div className="skill-cat-icon">{category.icon}</div>
      <div className="skill-cat-name">{category.name}</div>
      <div className="skill-tags">
        {category.tags.map((tag) => (
          <span className="skill-tag" key={tag}>
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}

export default SkillCategory;
